import type { CampaignInclusionPeriodI } from "~/modules/campaign/components/CampaignOperationMgrFunnelStep3InclusionPeriods.vue";
import type { CampaignInclusionPeriod } from "~/modules/campaign/models/CampaignInclusionPeriod";

export function campaignInclusionPeriodCreateUpdateMapper(
  campaignInclusionPeriods: CampaignInclusionPeriodI[],
  timezone?: string,
): CampaignInclusionPeriod[] {
  const campaignInclusionPeriodList: CampaignInclusionPeriod[] = [];

  campaignInclusionPeriods.forEach((period) => {
    const dayAbbreviation =
      period.day.substring(0, 1).toUpperCase() +
      period.day.substring(1, 2).toLowerCase();

    const existingPeriod = campaignInclusionPeriodList.find(
      (existingItem) =>
        existingItem.startTime === period.start &&
        existingItem.endTime === period.end,
    );

    if (existingPeriod) {
      existingPeriod.days += dayAbbreviation;
    } else {
      campaignInclusionPeriodList.push({
        days: dayAbbreviation,
        startTime: period.start,
        endTime: period.end,
        timezone,
      });
    }
  });

  return campaignInclusionPeriodList;
}
